import { render, staticRenderFns } from "./AwardUse.vue?vue&type=template&id=da727a2e&"
import script from "./AwardUse.vue?vue&type=script&lang=js&"
export * from "./AwardUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports